import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=bb359b2a&"
import script from "./Divider.vue?vue&type=script&lang=js&"
export * from "./Divider.vue?vue&type=script&lang=js&"
import style0 from "./Divider.vue?vue&type=style&index=0&id=bb359b2a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VDivider,VResponsive})
